import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnalyticsFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 2.25C3.48079 2.25 2.25 3.48079 2.25 5V19C2.25 20.5192 3.48079 21.75 5 21.75H19C20.5192 21.75 21.75 20.5192 21.75 19V5C21.75 3.48079 20.5192 2.25 19 2.25H5ZM16.75 7C16.75 6.58579 16.4142 6.25 16 6.25C15.5858 6.25 15.25 6.58579 15.25 7V17C15.25 17.4142 15.5858 17.75 16 17.75C16.4142 17.75 16.75 17.4142 16.75 17V7ZM12.75 11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11ZM8.75 15C8.75 14.5858 8.41421 14.25 8 14.25C7.58579 14.25 7.25 14.5858 7.25 15V17C7.25 17.4142 7.58579 17.75 8 17.75C8.41421 17.75 8.75 17.4142 8.75 17V15Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgAnalyticsFilled);
export default ForwardRef;
